import React from 'react';
import PropTypes from 'prop-types';
import AccessControlWrapper from './AccessControlWrapper';
import Icon from './Icon';
import InfoToolTip from './InfoTooltip';
import { Button as BootstrapButton } from 'react-bootstrap';
import { formatClassName } from '../Util';
import { kebabCase } from 'lodash';

/** renders a button */
const Button = ({ block, branded, children, className, cssStyle, data = {}, disabled, icon, iconFamily, label, onClick, rightIcon, rightIconFamily, style, tooltipAttributes = {}, ...additionalProps }) => {
  
  const buttonClassName = formatClassName([
    className,
    {
      [`btn-${style}-branded`]: branded,
      'btn-block': block,
      'no-label': !label
    }
  ]);

  const dataProps = {};
  if (data.action) {
    dataProps['data-action'] = data.action;
  }
  if (data.objectId) {
    dataProps['data-object-id'] = data.objectId;
  }
  if (data.objectType) {
    dataProps['data-object-type'] = data.objectType;
  }
  if (data.componentType) {
    dataProps['data-component-type'] = data.componentType;
  } else {
    dataProps['data-component-type'] = label ? `${kebabCase(label)}-button` : 'button';
  }

  const spin = icon && icon === "spinner";

  return (
    <AccessControlWrapper {...additionalProps}>
      <BootstrapButton
        {...additionalProps}
        {...dataProps}
        className={buttonClassName}
        disabled={disabled}
        bsStyle={style}
        style={cssStyle}
        onClick={onClick}>
        {icon && <Icon iconType={icon} fontFamily={iconFamily} spin={spin} additionalClasses="left" />}
        <span className="btn-text">{label}</span>
        {rightIcon && <Icon iconType={rightIcon} fontFamily={rightIconFamily} additionalClasses="right" />}
        {children}
      </BootstrapButton>
      {tooltipAttributes?.tooltip && (
        <InfoToolTip
          tooltipPosition="top"
          {...tooltipAttributes}
        />
      )}
    </AccessControlWrapper>
  );
}

Button.propTypes = {
  block: PropTypes.bool,
  branded: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  cssStyle: PropTypes.object,
  data: PropTypes.shape({
    action: PropTypes.string,
    objectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    objectType: PropTypes.string
  }),
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  iconFamily: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  rightIcon: PropTypes.string,
  rightIconFamily: PropTypes.string,
  style: PropTypes.oneOf([
    'primary', 'secondary', 'link', 'expand-link', 'pill', 'default'
  ]),
  tooltipAttributes: PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    tooltip: PropTypes.string,
    tooltipPosition: PropTypes.string,
    iconTooltip: PropTypes.string,
    trigger: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
  })
};

Button.defaultProps = {
  style: 'primary'
};

export default Button;
